import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Input, Popup } from 'semantic-ui-react'

const TextInput = (props) => {
  const {
    label,
    dummy,
    placeHolder,
    input,
    require,
    editable,
    filterKey,
    style,
    noBorder=false,
    maxLength,
    maxLengthMessage,
    lengthLimit=0,
    specialOnChange,
    footer='',
    tooltip=false,
    action=null, meta: { touched, error }
  } = props
  const showMaxLengthMessage = maxLengthMessage && maxLength && editable !== false && `${input.value || ''}`.length >= maxLength
  const activeClass = classnames({error: (touched && error) || showMaxLengthMessage})

  if (filterKey && input.value && input.value === filterKey) {
    input.value = '-'
  }

  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
        {!(touched && error) && showMaxLengthMessage ? <span className='error'>{maxLengthMessage}</span> : null}
      </span>
      <div className={`fieldInput textFieldInput ${editable!==false?'editableTextInput':''} ${noBorder?'inputNoBorder':''}`} style={dummy?{visibility:'hidden',maxHeight:0}:{}}>
        {(() => {
          const inputElement = (
            <Input
              {...input}
              action={action}
              fluid
              disabled={editable === false}
              maxLength={maxLength}
              className={`${activeClass}ellipsis`}
              placeholder={placeHolder}
              onChange={(e, data) => {
                input.onChange(data.value)
                if (specialOnChange) {
                  specialOnChange(data.value)
                }
              }}
            />
          )
          return tooltip && input.value
            ? <Popup trigger={<div>{inputElement}</div>} content={input.value} position='top center' basic />
            : inputElement
        })()}
      </div>
      <div>{footer}</div>
      {props.showEmpty&&!input.value&&editable==false&&<div style={{position:'absolute',marginTop:'2rem',marginLeft:'1rem'}}>-</div>}
    </div>
  )
}

export default compose()(TextInput)
